<template>
  <div class="contents contents--list">
    <h1>Circulating</h1>

    <div class="contents__detail-box">
      <div class="contents--list-subject">
        <span>Payprotocol</span>
      </div>

      <div class="contents__detail-table contents__circulating-detail-table">
        <div class="row">
          <span class="field">Max Supply</span>
          <span class="value">{{ max_supply.toLocaleString()}}</span>
        </div>

        <div class="row">
          <span class="field">Circulating Supply</span>
          <span class="value">{{ circulating_supply.toLocaleString() }}</span>
        </div>

        <div class="row">
          <span class="field">Updated Time(UTC +0)</span>
          <span class="value">{{ updated_time }}</span>
        </div>
      </div>

      <div class="search-box">
        <div class="search-inner-box">
          <span>Wrapped PCI(WPCI)</span>
          <button title="Go to Etherscan" @click="goto">
            <img src="../../assets/img/search.svg" alt="Search" />
            <span>Etherscan</span>
            <img src="../../assets/img/link.svg" alt="Link" style="opacity:0.5;" />
          </button>
        </div>
      </div>

      <div class="contents__detail-table contents__circulating-detail-table">
        <div class="row">
          <span class="field">Total Amount</span>
          <span class="value">{{ wpci_amount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import callAPI from "../../api/http";
import { styleNav } from "../../js/style";
import { etherScanUrl, tokenAddress } from "../../js/wpci";

export default {
  name: "Circulating",

  async created() {
    await this.getCirculating();
  },

  mounted() {
    styleNav(4);
  },

  data() {
    return {
      max_supply: 0,
      circulating_supply: 0,
      updated_time: "",
      wpci_amount: 0,
    };
  },

  methods: {
    goto() {
      window.open(etherScanUrl + "/token/" + tokenAddress)
    },

    async getCirculating() {
      const { data, errCode } = await callAPI("getCirculating");
      this.setCirculating(data, errCode);
    },

    setCirculating(data, errCode) {
      if (errCode) {
        console.log(errCode);
        return;
      }

      const { max_supply, circulating_supply, updated_time, wpci_amount } = data;
      this.max_supply = max_supply;
      this.circulating_supply = circulating_supply;
      this.updated_time = updated_time;
      this.wpci_amount = wpci_amount;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../scss/common";

.contents {
  &__circulating-detail-table {
    @include detailTableFieldWidth(177px);
  }

  &__detail-box {
    padding: 20px 20px 0;
  }

  &__detail-table {
    margin: 15px 0 20px;
  }
}

.search-box {
  overflow-x: auto;
}

.search-inner-box {
  min-width: 550px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  span {
    font-size: 14px;
    font-weight: bold;
  }

  button {
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 10px;
    background-color: #0393f4;
    color: #FFF;
    cursor: pointer;
  }

  button > img {
    width: 80%;
    height: auto;
  }

  button > span {
    font-size: 11px;
    margin: 0 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/Circulating.vue